// EVA-266 (Tier 1 unification): idempotency/echo key for optimistic grid writes,
// previously copy-pasted verbatim into five Handsontable grid components
// (Assumption/GrowthRates, OpEx, CapEx, Mla). Kept as the existing
// timestamp+random scheme — the value is opaque and only echoed back in
// ActionCable payloads for client-side matching, so this is behaviour-preserving.
export function generateRequestId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}
